export const emptyDocumentInfo = () => ({
  documentId: '',
  rowNumber: 0,
  signedUrl: '',
  audioUploaded: false,
  statusUpdated: false,
});
